<div class="container-fluid line-info p-0">
    <div class="row row-gap-3 pb-md-4 pb-lg-4">
        <div class="{{isLargeScreen?'col-12 gap-05  d-flex': (data?.viewConsignmentDetail ? 'viewConsignmentDetail col-6 col-sm-3' : 'containers col-12 col-sm-6')}}">

            <div [ngClass]="{'item1':!isLargeScreen}">
                <span class="d-flex mobile-view-primary-text text-gray">MPN</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.mpn ? data?.mpn : '-'}}</span>
            </div>
            <div [ngClass]="{'item2':!isLargeScreen}">
                <span class="d-flex mobile-view-primary-text text-gray">MFR</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.mfr ? data?.mfr : '-'}}</span>
            </div>
            <ng-container *ngIf="!data?.viewConsignmentDetail">
                <div [ngClass]="{'item3':!isLargeScreen}">
                    <span  *ngIf="!data?.consignmentDetail" class="d-flex mobile-view-primary-text text-gray">Unit Cost</span>
                    <span *ngIf="!data?.consignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.unitCost ? data?.unitCost : '-'}}</span>
                    <span *ngIf="data?.consignmentDetail" class="d-flex mobile-view-primary-text text-gray">Original Price/Unit</span>
                    <span *ngIf="data?.consignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.originalPrice ? data?.originalPrice : '-'}}</span>
                     
                </div>
                <div [ngClass]="{'item4':!isLargeScreen}">
                    <span class="d-flex mobile-view-primary-text text-gray">Rec. Date</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.date ? data?.date : todayDate}}</span>
                </div>
                <div [ngClass]="{'item5':!isLargeScreen}">
                    <span *ngIf="!data?.consignmentDetail" class="d-flex mobile-view-primary-text text-gray">Company</span>
                    <span *ngIf="data?.consignmentDetail" class="d-flex mobile-view-primary-text text-gray">Consignor</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.companyName ? data?.companyName : '-'}}</span>
                </div>
                <div [ngClass]="{'item6':!isLargeScreen}">
                    <span class="d-flex mobile-view-primary-text text-gray">Type</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.type ? data?.type : '-'}}</span>
                </div>
                <div *ngIf="data?.consignmentDetail">
                    <span class="d-flex mobile-view-primary-text text-gray">Contract End Date</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.contactEndDate ? data?.contactEndDate : '-'}}</span>
                </div>
    
            </ng-container>
            <!-- ****** viewConsignmentDetail Section***** -->
            <ng-container *ngIf="data?.viewConsignmentDetail">
                <div >
                    <span *ngIf="data?.inventoryLineDetail" class="d-flex mobile-view-primary-text text-gray"> Unit Cost</span>
                    <span *ngIf="data?.inventoryLineDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.unitCost ? data?.unitCost : '-'}}</span>
                    <span *ngIf="!data?.inventoryLineDetail"  class="d-flex mobile-view-primary-text text-gray">Original Price Unit</span>
                    <span *ngIf="!data?.inventoryLineDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.originalPrice ? data?.originalPrice : '-'}}</span>
                </div>
                <div >
                    <span  class="d-flex mobile-view-primary-text text-gray">Quantity</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.quantity ? data?.quantity : '-'}}</span>
                </div>
                <div >
                    <span  class="d-flex mobile-view-primary-text text-gray">On Hand</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.onHand ? data?.onHand : '-'}}</span>
                </div>
                <div >
                    <span  class="d-flex mobile-view-primary-text text-gray">Available</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.available ? data?.available : '-'}}</span>
                </div>
                <div >
                    <span  class="d-flex mobile-view-primary-text text-gray">Allocated</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.allocated ? data?.allocated : '-'}}</span>
                </div>
            </ng-container>
           <!-- ****** viewConsignmentDetail Section***** -->
          </div>
          <div class="{{isLargeScreen?'col-12  py-3 d-flex gap-05 ':(data?.viewConsignmentDetail ? 'viewConsignmentDetail col-6 col-sm-3' : 'containers col-12 col-sm-6')}}">
            <div [ngClass]="{'item1':!isLargeScreen}">
                <span class="d-flex mobile-view-primary-text text-gray">Standard Pkg</span>
                <span *ngIf="!data?.viewConsignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.standardPkg ? data?.standardPkg : '-'}}</span>
                <span *ngIf="data?.viewConsignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.standardPackagingName ? data?.standardPackagingName : '-'}}</span>
                
            </div>
            <div [ngClass]="{'item2':!isLargeScreen}">
                <span class="d-flex mobile-view-primary-text text-gray">SPQ</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.spq ? data?.spq : '-'}}</span>
            </div>
            <div [ngClass]="{'item3':!isLargeScreen}">
                <span class="d-flex mobile-view-primary-text text-gray">UoM</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.uomName ? data?.uomName : '-'}}</span>
            </div>
            <div [ngClass]="{'item4':!isLargeScreen}">
                <span class="d-flex mobile-view-primary-text text-gray">Warehouse</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.warehouse ? data?.warehouse : '-'}}</span>
            </div>
            <div [ngClass]="{'item5':!isLargeScreen}">
                <span class="d-flex mobile-view-secondary-text text-gray">Location</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.location ? data?.location : '-'}}</span>
            </div>
            <div [ngClass]="{'item6':!isLargeScreen}"> 
                <span class="d-flex mobile-view-primary-text text-gray">Received In</span>
                <span *ngIf="!data?.viewConsignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.receivedIn ? data?.receivedIn : '-'}}</span>
                <span *ngIf="data?.viewConsignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.receivedInName ? data?.receivedInName : '-'}}</span>

            </div>
            <div [ngClass]="{'item7':!isLargeScreen}">
                <span class="d-flex mobile-view-primary-text text-gray">Received Pkg</span>
                <span *ngIf="!data?.viewConsignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.receivedPackage ? data?.receivedPackage : '-'}}</span>
                <span *ngIf="data?.viewConsignmentDetail" class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.receivedPackagingName ? data?.receivedPackagingName : '-'}}</span>

            </div>

          </div>
        <!-- ****** viewConsignmentDetail Section***** -->
        <ng-container *ngIf="data?.viewConsignmentDetail">
            <ng-container *ngIf="!data?.inventoryLineDetail"> 
            <div class="{{isLargeScreen?'':'col-12 col-sm-6'}}">
                <div class="{{isLargeScreen?'col-12 d-flex gap-05':'ConsignmentDetail col'}}">
            <div [ngClass]="{'item1':!isLargeScreen}">
                <span  class="d-flex mobile-view-primary-text text-gray">Consignor</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.consignor ? data?.consignor : '-'}}</span>
            </div>
            <div [ngClass]="{'item2':!isLargeScreen}">
                <span  class="d-flex mobile-view-primary-text text-gray">Type</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.companyTypeName ? data?.companyTypeName : '-'}}</span>
            </div>
            <div [ngClass]="{'item3':!isLargeScreen}">
                <span  class="d-flex mobile-view-primary-text text-gray">CPN</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.cpn ? data?.cpn : '-'}}</span>
            </div>
            <div [ngClass]="{'item4':!isLargeScreen}">
                <span  class="d-flex mobile-view-primary-text text-gray">Rec. Date</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.recDate ? (data?.recDate | date: 'MM/dd/yyyy') : '-'}}</span>
            </div>
            <div [ngClass]="{'item5':!isLargeScreen}">
                <span  class="d-flex mobile-view-primary-text text-gray">Payout Price/Unit</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.payoutPrice ? data?.payoutPrice : '-'}}</span>
            </div>
            <div [ngClass]="{'item6':!isLargeScreen}">
                <span  class="d-flex mobile-view-primary-text text-gray">Payout %</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.payoutPercentage ? data?.payoutPercentage : '-'}}</span>
            </div>
            <div [ngClass]="{'item7':!isLargeScreen}">
                <span  class="d-flex mobile-view-primary-text text-gray">Purchase PO</span>
                <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.purchasePO ? data?.purchasePO : '-'}}</span>
            </div>
        </div>
        <div [ngClass]="{'d-none':isLargeScreen}" class="col-12">
            <div class="pe-5 pb-4">
                <span  class="d-flex mobile-view-primary-text text-gray">Notes</span>
                <span class="mobile-view-secondary-text text-primary-color noteWrapper d-block w-100">{{data?.notes ? data?.notes : '-'}}</span>
            </div>
        </div>
            </div>
        </ng-container>
            <ng-container *ngIf="data?.inventoryLineDetail">
                <div class="{{isLargeScreen?'':'col-12 col-sm-6'}}">
                <div class="{{isLargeScreen?'col-12 d-flex gap-05':'ConsignmentDetail col'}}"> 
                <div [ngClass]="{'item1':!isLargeScreen}">
                    <span class="d-flex mobile-view-primary-text text-gray">Company</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.companyName ? data?.companyName : '-'}}</span>
                </div>
                <div [ngClass]="{'item2':!isLargeScreen}">
                    <span  class="d-flex mobile-view-primary-text text-gray">Type</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.companyTypeName ? data?.companyTypeName : '-'}}</span>
                </div>
                <div [ngClass]="{'item3':!isLargeScreen}">
                    <span  class="d-flex mobile-view-primary-text text-gray">Rating</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.rating ? data?.rating : '-'}}</span>
                </div>
                <div [ngClass]="{'item5':!isLargeScreen}">
                    <span  class="d-flex mobile-view-primary-text text-gray">PO Date</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.poDate ? (data?.poDate | date: 'MM/dd/yyyy') : '-'}}</span>
                </div>
                <div [ngClass]="{'item4':!isLargeScreen}">
                    <span  class="d-flex mobile-view-primary-text text-gray">Rec. Date</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.recDate ? (data?.recDate | date: 'MM/dd/yyyy') : '-'}}</span>
                </div>
                <div [ngClass]="{'item6':!isLargeScreen}">
                    <span  class="d-flexmobile-view-primary-text text-gray">PO No</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.poNo ? data?.poNo : '-'}}</span>
                </div>
                <div>
                    <span  class="d-flex mobile-view-primary-text text-gray">PO Qty</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate  d-block w-100">{{data?.qty ? data?.qty : '-'}}</span>
                </div>
            </div>
            <div [ngClass]="{'d-none':isLargeScreen}" class="col-12">
                <div class="pe-5 pb-4">
                    <span  class="d-flex mobile-view-primary-text text-gray">Notes</span>
                    <span class="mobile-view-secondary-text text-primary-color noteWrapper d-block w-100">{{data?.notes ? data?.notes : '-'}}</span>
                </div>
            </div>
        </div>
            </ng-container>

            <div [ngClass]="{'d-none':!isLargeScreen}" class="col-12 py-3">
                <div class="pe-5">
                    <span  class="d-flex mobile-view-secondary-text text-gray">Notes</span>
                    <span class="mobile-view-secondary-text text-primary-color text-truncate pe-5 d-block w-100">{{data?.notes ? data?.notes : '-'}}</span>
                </div>
            </div>
            </ng-container>
            

         <!-- ****** viewConsignmentDetail Section***** -->


    </div>
    <div *ngIf="data?.viewConsignmentDetail" class="row py-2">
    <app-view-consignment-tab 
        [data]="data">
    </app-view-consignment-tab>
    </div>
    <div *ngIf="!data?.viewConsignmentDetail" class="row py-2">
        <app-table
        [data]="data" 
        [formModel]="formModel" 
        >
       </app-table>
    </div>
</div>